import { get, post, qs } from './http.ts';
import type { TrashItem } from './types.ts';

export const listTrash = (
  namespaceId: string,
  before?: string,
): Promise<{
  items: TrashItem[]; next_cursor: string | null; total_size: number; retention_days: number;
}> =>
  get(`/trash${qs({ namespace_id: namespaceId, limit: 100, ...(before ? { before } : {}) })}`);

export const trashItems = (
  namespaceId: string, trashId: string,
): Promise<{ items: Array<{ path: string; type: string; size: number }> }> =>
  get(`/trash/${trashId}/items${qs({ namespace_id: namespaceId, limit: 500 })}`);

export const restoreTrash = (
  namespaceId: string, trashIds: string[], conflict: 'rename' | 'skip' = 'rename',
): Promise<{ restored: Array<{ trash_id: string; path: string; renamed: boolean }>;
  skipped: Array<{ trash_id: string; reason: string }> }> =>
  post('/trash/restore', { namespace_id: namespaceId, trash_ids: trashIds, conflict });

export const purgeTrash = (
  namespaceId: string, trashIds: string[],
): Promise<{ purged: string[]; freed_bytes: number; deleted_items: number }> =>
  post('/trash/purge', { namespace_id: namespaceId, trash_ids: trashIds });

export const emptyTrash = (
  namespaceId: string,
): Promise<{ purged: string[]; freed_bytes: number; deleted_items: number }> =>
  post('/trash/empty', { namespace_id: namespaceId });
